/* istanbul ignore file */
import { oneOf as codecOneOf } from 'purify-ts/Codec';
import { FinalizedLTI1p1Provider } from './FinalizedLTI1p1Provider';
import { NonFinalizedLTI1p1Provider } from './NonFinalizedLTI1p1Provider';
const LTI1p1ProviderParser = 
/* #__PURE__ */ /* #__PURE__ */ codecOneOf([
    NonFinalizedLTI1p1Provider,
    FinalizedLTI1p1Provider,
]);
export const LTI1p1Provider = LTI1p1ProviderParser;
